export class ProgramCounter {
}

//# sourceMappingURL=ProgramCounter.js.map
